<!-- Main content starts from here -->
<div id="myAcContent" class="content__wrapper">
    <div id="myAccCard" class="my_acc_card">
        <div id="myAccHeader" class="my_acc_header"><span i18n="@@my-account.edit-account.heading.ipos-central-account-tile">My IPOS  Central Account</span></div>
        <div id="myAccTextCenter" class="text-center mb-4 required_label">
          <span class="mandatory_red">*</span> <span i18n="@@my-account.edit-account.required-field-label">Indicates a required field</span>
        </div>
        <div id="myAccTextCaps" class="font-weight-bold text-caps">
            <span i18n="@@my-account.edit-account.heading.content-details">Edit the details of your IPOS Central user account below.</span>
        </div>
        <hr />
        <form [formGroup]="editAccountForm">
          <div id="myAccFormSectionName" class="form_section">
              <div id="myAccFormGroupFirstName" class="form-group">
                  <label for="firstName">{{firstNameHeading}}<span class="mandatory_red">*</span></label>
                  <input @keydown.space.prevent type="text" class="form-control" id="firstName" maxlength="50" formControlName="firstName" required />
                  <em class="err_icon1"></em>
                  <span id="firstNameErrMsg" class="formfield_err_msg"></span>
              </div>
              <div id="myAccFormGroupLastName" class="form-group">
                  <label for="lastName">{{lastNameHeading}}<span class="mandatory_red">*</span></label>
                  <input @keydown.space.prevent type="text" class="form-control" id="lastName" maxlength="50" formControlName="lastName" required />
                  <em class="err_icon1"></em>
                  <span id="lastNameErrMsg" class="formfield_err_msg"></span>
              </div>
          </div>
          <div id="myAccFormSectionEmail" class="form_section">
              <div id="myAccFormGroupEmail" class="form-group">
                  <label for="emailId">{{emailAddressHeading}}<span class="mandatory_red">*</span></label>
                  <input type="email" class="form-control" id="emailId" formControlName="email" disabled />
              </div>
          </div>
          <div id="changePwdPopupText" class="mt-3">
              <a (click)="openChangePasswordPopup()" class="change_pwd gtmAccountMyAccountChangePassword"><span i18n="@@my-account.edit-account.change-password-button-name">Change Your IPOS Central Account Password</span></a>
          </div>
          <hr />

          <div id="myAccFormSectionLoc" class="form_section">
              <div id="myAccFormGroupLoc" class="form-group">
                  <label for="countrySelect">{{countryHeading}}<span class="mandatory_red">*</span></label>
                  <select class="form-control" id="countrySelect" formControlName="location" disabled>
                      <option *ngFor="let country of locationList;">{{country}}</option>
                  </select>
              </div>
          </div>
          <div id="myAccFormSectionRetailer" class="form_section" *ngIf = '!isUserAuthor'>
              <div id="myAccFormGroupRetailer" class="form-group">
                  <label for="retailerName">{{retailerNameHeading}}<span class="mandatory_red">*</span></label>
                  <input type="text" class="form-control" id="retailerName" formControlName="retailerName" disabled />
              </div>
              <div id="myAccFormGroupStore" class="form-group">
                  <label for="storeName">{{storeNameHeading}}</label>
                  <input type="text" class="form-control" id="storeName" formControlName="storeName" disabled />
              </div>
          </div>
          <hr/>

          <div id="myAccFormGroupEmailNotif" class="form-check" *ngIf = '!isUserAuthor'>
              <input id="receiveEmailNotif" class="form-check-input" type="checkbox" formControlName="emailNotification" [checked]="editAccountForm.controls.emailNotification" />
              <label for="receiveEmailNotif" class="form-check-label"><span i18n="@@my-account.edit-account.checkbox-label-name">Receive Email Notifications</span></label>
          </div>

          <div id="myAccFormUpdateBtn" class="button_wrapper justify-content-end">
              <button class="btn btn-outline-primary btn-lg gtmAccountMyAccountCancel" (click)="gotoPreviousPage()"><span i18n="@@my-account.edit-account.cancel-button">Cancel</span></button>
              <button class="btn btn-primary btn-lg gtmAccountMyAccountSaveChanges" type="button" (click)="updateUserAccount()" [disabled]="editAccountForm.invalid || (!editAccountForm.controls.firstName.value.trim() || !editAccountForm.controls.lastName.value.trim())"><span i18n="@@my-account.edit-account.save-button-name">Save Changes</span></button>
          </div>
        </form>
    </div>
</div>

<!-- Change Password Modal -->

<div id="changePwdDailogModalCentered" class="modal-dialog-centered change-pwd-dialog" *ngIf="changePwdPopup">
    <div id="changePwdModalBackdrop" class="modal-backdrop show"></div>
    <div class="modal" id="myModal">
        <div id="changePwdDailogModal" class="modal-dialog">
            <div id="changePwdDailogModalContent" class="modal-content">
                <div id="changePwdDailogModalClose" class="close modal_close_icons" data-dismiss="modal" (click)="closePopup()"></div>
                <div id="changePwdDailogModalBody" class="modal-body">
                    <div id="changePwdDailogModalHeading" class="heading"><span i18n="@@my-account.edit-account.heading.change-account-password">Change Account Password</span></div>

                    <form [formGroup]="changePWDForm" autocomplete="off">
                       
                        <div id="changePwdFormGroupPwd" class="form-group">
                            <label for="currentPassword" [innerHTML]="mandatoryCurrentPassword"></label><span class="text-danger">*</span>
                            <input [type]="fieldCurrentTextType ? 'text' : 'password'" class="form-control text_overlap" required (input)="checkCurrentPassword($event.target.value)"
                            formControlName="currentPassword" [placeholder]="placeholderCurrentPassword" />

                            <fa-icon *ngIf="formControls.currentPassword.value" class="input-icon"
                            [icon]="displayCurrEyePassword" [ngClass]="{
                                'eye-slash': fieldCurrentTextType,
                                'eye': !fieldCurrentTextType
                                }" (click)="toggleCurrentFieldTextType()"></fa-icon>

                        </div>

                        <div id="changePwdFormGroupValidation" class="form-group">
                            <ng-template #pwdPopup>
                                <div id="pwdMaxChar" class="d-flex">
                                  <span *ngIf="!isMaxChar" class="error_mark"></span> 
                                  <span *ngIf="isMaxChar" class="rigth_mark"></span>
                                  <span i18n="@@my-account.edit-account.validation-text.contain-atleast-five-characters">At least 5 characters</span>
                                </div>
                                <div id="pwdUpperCase" class="d-flex">
                                  <span *ngIf="!isUpperCase" class="error_mark"></span> 
                                  <span *ngIf="isUpperCase" class="rigth_mark"></span>
                                  <span i18n="@@my-account.edit-account.validation-text.contain-uppercase-letter">Contains an uppercase letter</span>
                                </div>
                                <div id="pwdLowerCase" class="d-flex">
                                  <span *ngIf="!isLowerCase" class="error_mark"></span> 
                                  <span *ngIf="isLowerCase" class="rigth_mark"></span>
                                  <span i18n="@@my-account.edit-account.validation-text.contain-lowercase-letter">Contains a lowercase letter</span>
                                </div>
                                <div id="pwdNumeric" class="d-flex">
                                  <span *ngIf="!isNumeric" class="error_mark"></span> 
                                  <span *ngIf="isNumeric" class="rigth_mark"></span>
                                  <span i18n="@@my-account.edit-account.validation-text.contain-number">Contains a number</span>
                                </div>
                                <div id="pwdSymbol" class="d-flex">
                                  <span *ngIf="!isSymbol" class="error_mark"></span> 
                                  <span *ngIf="isSymbol" class="rigth_mark"></span>
                                  <span i18n="@@my-account.edit-account.validation-text.contain-symbol">Contains a symbol</span>
                                </div>
                              </ng-template>

                            <label for="password" [innerHTML]="mandatoryPassword"></label><span class="text-danger">*</span>
                            <input [ngClass]="{'has-error': formControls.password.touched && dsiplayError}" [type]="fieldTextType ? 'text' : 'password'" class="form-control text_overlap" id="password" maxlength="50" formControlName="password"
                              [placeholder]="placeholderPassword" (input)="checkPasswordValidation($event.target.value)"
                              placement="top" [ngbPopover]="pwdPopup" triggers="focus" />

                            <em class="err_icon" *ngIf="formControls.password.touched && dsiplayError"></em>
                            <em class="success_icons" *ngIf="formControls.password.touched && formControls.password.valid && !dsiplayError"></em>
                            <fa-icon *ngIf="formControls.password.value" class="input-icon"
                            [icon]="displayEyePassword" [ngClass]="{
                                'eye-slash': fieldTextType,
                                'eye': !fieldTextType
                                }" (click)="toggleFieldTextType()"></fa-icon>

                            <div id="pwdErrMsg" *ngIf="formControls.password.touched && dsiplayError" class="formfield_err_msg">
                                <span i18n="@@global.password-mustcontain-least-8-characters-rule">Password must contain at least 8 characters (with minimum one uppercase letter, one lowercase letter, one number and one special character)</span>
                            </div>

                        </div>

                        <div id="changePwdFormGroupCnfPwd" class="form-group">
                            <ng-template #cnfpwdPopup>
                              <div id="changePwdMatch" class="d-flex">
                                <span *ngIf="!isPasswordMatch" class="error_mark"></span> 
                                <span *ngIf="isPasswordMatch" class="rigth_mark"></span>
                                <span i18n="@@my-account.edit-account.validation-text.password-match">Passwords match</span>
                              </div>
                            </ng-template>
                
                            <label for="cnfPassword" [innerHTML]="mandatoryConfPassword"></label><span class="text-danger">*</span>
                              <input [ngClass]="{ 'has-error': formControls.cnfPassword.touched && formControls.cnfPassword.invalid && !isPasswordMatch }" [type]="repeatFieldTextType ? 'text' : 'password'" class="form-control text_overlap" id="cnfPassword"
                                formControlName="cnfPassword" [placeholder]="placeholderCnfPassword" maxlength="30" placement="top" [ngbPopover]="cnfpwdPopup" triggers="keypress:focusout" required (input)="checkCnfPasswordValidation($event.target.value)"/>
                                <em class="err_icon" *ngIf="formControls.cnfPassword.touched && formControls.cnfPassword.invalid && !isPasswordMatch"></em>
                                <em class="success_icons" *ngIf="formControls.cnfPassword.touched && formControls.cnfPassword.valid && isPasswordMatch"></em>
                                  <fa-icon *ngIf="formControls.cnfPassword.value" class="input-icon" [icon]="displayEyeCnfPassword"
                                    [ngClass]="{
                                          'eye-slash': repeatFieldTextType,
                                          'eye': !repeatFieldTextType
                                        }" (click)="toggleRepeatFieldTextType()"></fa-icon>
                                
                                 <div id="changePwdErrMsg" *ngIf="formControls.cnfPassword.touched && formControls.cnfPassword.invalid" class="formfield_err_msg">
                                  <div id="changePwdMatchErrMsg" *ngIf="!isPasswordMatch">
                                    <span i18n="@@my-account.edit-account.validation-text.password-do-not-match">Passwords do not match</span>
                                  </div>
                              </div>
            
                          </div>


                    </form>
                    <span *ngIf="errorMessage && isSubmitted" class="error-msg">{{showErrorMessage}}</span>
                </div>
                <div id="myAccModalFooter" class="modal-footer">
                    <button type="button" class="btn btn-outline-primary btn-lg gtmAccountMyAccountCancel" (click)="closePopup()">
                        <span i18n="@@my-account.edit-account.cancel-button">Cancel</span>
                    </button>
                    <button type="button" class="btn btn-primary btn-lg gtmChangeMyAccountPwd" (click)="changeAccountPassword()" [disabled]="!isPasswordMatch || dsiplayError || !checkCurrPwd">
                        <span i18n="@@my-account.edit-account.change-password-button">Change Password</span>
                    </button>
                </div>
            </div>

        </div>
    </div>
</div>

<div id="changePwdDailogCentered" class="modal-dialog-centered change-pwd-dialog" *ngIf="pwdSuccessModal">
  <div id="changePwdModalBackdrop" class="modal-backdrop show"></div>
  <div  class="modal" id="myModal">
    <div id="changePwdModalDailog" class="modal-dialog">
      <div id="changePwdModalContent" class="modal-content">
        <div id="changePwdModalClose" class="close modal_close_icons" data-dismiss="modal" (click)="closePwdPopup()"></div>
        <div  id="changePwdModalBody" class="modal-body">
          <div id="changePwdModalBodyContent" class="success-panel">
            <h5><span >{{userAccountTitle}}</span></h5>
            <p><span >{{userAccountSuccessMsg}}</span></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<iposcen-spinner-overlay *ngIf="showRetailGif" [isCard]="true"></iposcen-spinner-overlay>